import { Table, Text } from '@factorialco/deprecated-design-system'
import {
  PayrollConceptFragment,
  TimeSettingsCustomTimeRangeCategoryFragment,
} from 'generated/resources/graphql'
import { isNumber } from 'lodash'

import { PayrollConceptSelect } from 'modules/compensations/components/PayrollConceptSelectField'
import { PayrollConceptWithCategory } from 'modules/compensations/components/PayrollConceptSelectField/CategorizedPayrollConceptUtil'

interface Props {
  timeCategory: TimeSettingsCustomTimeRangeCategoryFragment
  payrollConcept: PayrollConceptFragment | undefined
  payrollConcepts: PayrollConceptWithCategory[]
  onRowChanged: (timeCategoryId: number, payrollConceptId: number) => void
}

const TimeReimbursementRow = ({
  timeCategory,
  payrollConcept,
  payrollConcepts,
  onRowChanged,
}: Props) => {
  return (
    <Table.Row>
      <Table.Cell sticky={{ position: 'left', delimiter: true }}>
        <Text.Normal>{timeCategory.name}</Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <PayrollConceptSelect
          payrollConcepts={payrollConcepts}
          value={payrollConcept?.id ? [payrollConcept.id] : []}
          onChange={(payrollConceptId) => {
            isNumber(payrollConceptId) && onRowChanged(timeCategory.id, Number(payrollConceptId))
          }}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default TimeReimbursementRow
